module.exports = __webpack_public_path__ + "img/consul-03z.b6120220.jpg";